export const environment = {
  production: true,
  baseUrl: 'https://millionshow.kr',
  kakao: {
    clientId: 'd25cfccfbfb965f53f9b67da0887af7b',
  },
};
